import { ReassignPartsCancelledRequest } from '@/main/models/request';
import {
  PartTypeSupplierIgnore,
  PartTypeSupplierIgnoreRequest
} from '@/main/models/request/partTypeSupplierIgnoreRequest';
import { isNullUndefinedEmpty } from '@/main/services/utils';
import { currencyToNumber } from '@/main/services/utilsNumber';
import { ReassignForm, ReassignPartData } from './reassignScreenUtils';

export function buildReassignRequests(
  data: ReassignForm
): ReassignPartsCancelledRequest[] {
  const requestSelect: ReassignPartsCancelledRequest[] = data.parts
    .filter(p => !isNullUndefinedEmpty(p.selectedGuidQuoteSupplierItem))
    .map(part => {
      const selectedItem = part.supplierItems.find(
        si => si.guidQuoteSupplierItem === part.selectedGuidQuoteSupplierItem
      );
      const newPrice = selectedItem?.price;

      return {
        guidProcurementSupplierItem: part.guidProcurementSupplierItem,
        guidReason: String(part.reason?.key),
        guidChosenQuoteSupplierItem:
          part.selectedGuidQuoteSupplierItem ?? undefined,
        reasonDescription: part.reasonDescription
          ? String(part.reasonDescription)
          : undefined,
        newDeliveryDeadline: Number(selectedItem?.deliveryDeadline),
        newPrice: newPrice
          ? (currencyToNumber(newPrice) ?? undefined)
          : undefined,
        idNewPartType: Number(selectedItem?.partType?.default)
      };
    });

  const requestDirectAssign: ReassignPartsCancelledRequest[] = data.parts
    .filter(p => !isNullUndefinedEmpty(p.directAssign))
    .map(part => {
      const newPrice = part.directAssign?.price;
      return {
        guidProcurementSupplierItem: part.guidProcurementSupplierItem,
        guidReason: String(part.reason?.key),
        guidNewSupplier: String(part.directAssign?.supplier?.key),
        reasonDescription: part.reasonDescription
          ? String(part.reasonDescription)
          : undefined,
        newDeliveryDeadline: Number(part.directAssign?.deliveryDeadline),
        idNewPartType: Number(part.directAssign?.partType?.default),
        newPrice: newPrice
          ? (currencyToNumber(newPrice) ?? undefined)
          : undefined
      };
    });

  return [...requestSelect, ...requestDirectAssign];
}

export function buildPartTypeSupplierIgnoreRequest(
  data: ReassignForm,
  partsData: ReassignPartData[]
): PartTypeSupplierIgnoreRequest {
  const partTypeSupplierIgnores: PartTypeSupplierIgnore[] = [];

  data.parts.forEach((part, index) => {
    const originalPart = partsData[index];
    if (!originalPart) return;

    if (!isNullUndefinedEmpty(part.selectedGuidQuoteSupplierItem)) {
      const originalItem = originalPart.itemAnswers.find(
        a =>
          a.guidAnsweredQuoteSupplierItem ===
          part.selectedGuidQuoteSupplierItem
      );
      const formItem = part.supplierItems.find(
        si => si.guidQuoteSupplierItem === part.selectedGuidQuoteSupplierItem
      );
      if (!originalItem) return;

      partTypeSupplierIgnores.push({
        guidQuoteItem: originalPart.guidQuoteItem,
        guidSupplier: originalItem.guidSupplier,
        guidPartType: '',
        idPartType: Number(
          formItem?.partType?.default ?? originalItem.idPartType
        ),
        guidQuoteSupplierItem: ''
      });
      return;
    }

    if (!isNullUndefinedEmpty(part.directAssign)) {
      const guidQuoteItem = originalPart.guidQuoteItem;
      const guidSupplier = part.directAssign?.supplier?.key;
      if (!guidQuoteItem || !guidSupplier) return;

      partTypeSupplierIgnores.push({
        guidQuoteItem,
        guidSupplier: String(guidSupplier),
        guidPartType: '',
        idPartType: Number(part.directAssign?.partType?.default),
        guidQuoteSupplierItem: ''
      });
    }
  });

  return { partTypeSupplierIgnores };
}
